// extracted by mini-css-extract-plugin
module.exports = {"accent":"#ff4200","white":"#fff","black":"#000"};